import React from 'react';
import { Col, Row } from 'antd';
import styled from 'styled-components';

import { StyledRow } from '../StyledRow';

type FormDoubleInputProps = {
  leftInput: React.ReactNode;
  rightInput: React.ReactNode;
  withDivider?: boolean;
};

const StyledDivider = styled.span`
  height: 2rem;
  align-items: flex-end;
  color: rgba(0, 0, 0, 0.25);
`;

export const FormDoubleInput: React.FC<FormDoubleInputProps> = ({ leftInput, rightInput, withDivider }) => {
  return withDivider ? (
    <StyledRow gap="0.36rem">
      {leftInput}
      <StyledDivider>-</StyledDivider>
      {rightInput}
    </StyledRow>
  ) : (
    <Row gutter={[10, 5]} wrap>
      <Col xs={24} sm={12}>
        {leftInput}
      </Col>
      <Col xs={24} sm={12}>
        {rightInput}
      </Col>
    </Row>
  );
};
